import axios from '../API/axios';

export const getExportReasons = () => {
  return axios.get('customs/reasons');
};
